module.exports = __webpack_public_path__ + "img/mobiliteitscoach-logo.681f4546.svg";